import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  const embedCode = `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          body { margin: 0; font-family: sans-serif; }
        </style>
      </head>
      <body>
        <div id="VVdwbU1URnNMek4xTjJaa1pXYzlQUT09" class="policy_embed_div" width="640" height="480"> 
          Please wait while the policy is loaded. If it does not load, please <a rel="nofollow" href="https://policies.termageddon.com/api/policy/VVdwbU1URnNMek4xTjJaa1pXYzlQUT09" target="_blank">click here</a> to view the policy.
        </div>
        <script src="https://policies.termageddon.com/api/embed/VVdwbU1URnNMek4xTjJaa1pXYzlQUT09.js"></script>
      </body>
    </html>
  `;

  return (
    <div className="min-h-screen bg-white p-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="text-blue-600 hover:underline mb-4 block">&larr; Back to Home</Link>
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
        <iframe
          title="Terms of Service"
          srcDoc={embedCode}
          style={{ width: '100%', minHeight: '800px', border: 'none' }}
        />
      </div>
    </div>
  );
};

export default TermsOfService;
